module.exports = __webpack_public_path__ + "media/vineyard.049e417d.jpg";